import { render, staticRenderFns } from "./luckBoxes.vue?vue&type=template&id=377a2824&scoped=true&"
import script from "./luckBoxes.vue?vue&type=script&lang=js&"
export * from "./luckBoxes.vue?vue&type=script&lang=js&"
import style0 from "./luckBoxes.vue?vue&type=style&index=0&id=377a2824&prod&lang=css&"
import style1 from "./luckBoxes.vue?vue&type=style&index=1&id=377a2824&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377a2824",
  null
  
)

export default component.exports